import { render, staticRenderFns } from "./PairSummary.vue?vue&type=template&id=2d5f2ddc&scoped=true&"
import script from "./PairSummary.vue?vue&type=script&lang=ts&"
export * from "./PairSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PairSummary.vue?vue&type=style&index=0&id=2d5f2ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f2ddc",
  null
  
)

export default component.exports